export const isValidEmailFormat = (email: string) =>
  !!email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)

/** When Cognito has no given/family name from SSO, it may store the email in those attributes — skip prefill for profile forms. */
export const isEmailLike = (value: string | undefined | null): boolean =>
  typeof value === 'string' && value.trim().length > 0 && isValidEmailFormat(value.trim())
